import React from 'react'
import {connect, useDispatch} from "react-redux";

import {send_edit_cmd} from "../etc/cmd";

import {useDrag} from "react-dnd";
import {selectItem, setGuiState} from "../../data/actions";

const Lc = ({lc, gs}) => {
    const mytype = 'lc'

    const dispatch = useDispatch()
    const lcid = lc && lc.id
    const show = gs && gs.show

    const [{ isDragging, opacity }, drag, dragPreview] = useDrag(() => ({
        type: mytype,
        item: {
            id: lc.id,
            type: mytype,
        },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult()
            if (item && dropResult) {
                if ( item.type === mytype && (dropResult.type === 'sg' || dropResult.type === 'bk') ) {
                    let target = {}
                    target.id = dropResult.id
                    target.lcid = item.id | ""
                    send_edit_cmd(target)
                }
                if (item.type === mytype && dropResult.type === mytype) {
                    console.log("DTR [%s] -> [%s]", item.id, dropResult.id)
                    let target = {}
                    target.id = dropResult.id
                    target.dtr = item.id || ''
                    send_edit_cmd(target)
                }

                if( dropResult.typename === "wastebin") {
                    console.log("DELETE %s", lc.id)
                    let target = {}
                    target.id = lc.id
                    target.deleted = true

                    send_edit_cmd(target)
                }
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            opacity: monitor.isDragging() ? 0.4 : 1,
        })
    }))

    const style = {
        width:'auto',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'monospace',
        cursor: 'default',
    };

    function modeClick(lc) {
        let cc = {
            name: "lc",
            id: lcid,
            mode: lc.mode === "auto" ? "man" : "auto"
        };
        console.log(cc);

        send_edit_cmd(cc);
    }

    function lcClick() {
        dispatch(setGuiState({
            id: lcid,
            show: true,
        }))
    }

    function onContext(e) {
        e.preventDefault()
        dispatch(selectItem(lc))
    }

    function reverseClick() {
        send_edit_cmd({id: lc.id, reversed: !(lc.reversed === true || lc.reversed === "true")})
    }

    return (
        <>


            <div
                 ref={drag}
                 className='unit lc'
                 style={{...style, opacity}}
                 key={lcid}
                 onContextMenu={onContext}
            >
                <span>{lc.bmdir === "E" ? "+" : "-"}&nbsp;</span>
                <span
                    onClick={() => lcClick(lc.id)}
                    style={{
                        width: '32px',
                    }}
                >
                    {lc && lc.id ? lc.id + "" + ((lc.dtr && lc.dtr !== "" && lc.dtr !== "") ? "::" + lc.dtr : "") : "[|||]"}
                </span>
                <span style={{float: 'right'}}>

                <span>{lc.v ? parseInt(lc.v) : "0"}</span>
                <span /*onClick={() => dirClick(lc)}*/>{lc && lc.dir ? "  >  " : "  <  "}</span>
                <span onClick={reverseClick}>{(lc.reversed === true || lc.reversed === "true") ? ":" : "."}</span>
                    {/*}
                <span
                    onClick={() => modeClick(lc)}
                    style={{ //background: lc.mode === "auto" ? "rgb(224,255,217)" : "#ffe0df",
                        paddingTop: '3px',
                        paddingBottom: '1px',
                        paddingRight: '5px',
                        paddingLeft: '5px',
                        color: lc.mode === "auto" ? "#438035" : "#bb2e25"
                    }}>{lc.mode === "auto" ? "A" : "M"}
                </span>
                */}
                </span>


            </div>
        </>
)


}







const mapStateToProps = ((state, other) => {
    var itm = state.plan.items.find((itm) => {
        return itm.id === other.lc.id
    });

    if (!itm) {
        itm = {}
    }

    var gitm = state.root.gui_state.find((itm) => {
        return itm.id === other.lc.id
    });

    return {lc: itm, gs: gitm}
})

export default connect(mapStateToProps)(Lc)


